var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlannedTaskLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 40,
    height: 40,
    id: "img4",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iOSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzAwNTg1NyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff;stroke: #81818c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14 27.5c-7.5 0-13.5-6-13.5-13.5c0-7.5 6-13.5 13.5-13.5c7.5 0 13.5 6 13.5 13.5c0 7.5-6 13.5-13.5 13.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Ellipse 47",
    href: "#img4",
    transform: "matrix(.55,0,0,.55,3,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannedTaskLog);
export default __webpack_public_path__ + "static/media/PlannedTaskLog.f311f297.svg";
export { ForwardRef as ReactComponent };